<template>
    <div style="display: block; justify-items: center"> 
      <el-row :gutter="30" type="block" justify="center" >
        <div v-for="(item, index) in strategiesList" :key="index">
          <el-col :span="375">
            <el-card :body-style="{padding: '0px'}" class="el-card">
              <router-link :to="{name:'strat_detail_amchart', query:{file:item.name, ben_name:item.ben_name}}" custom v-slot="{ navigate }">
                <button class="strategy_card" @click="navigate" role="link">
                  <!-- UI for card-->
                  <div class="card">
                    <div class="heading">
                        <div class="title">{{ item.name }}</div>
                        <div style="flex: 1px"></div>
                        <div class="author">{{ item.author }}</div>
                    </div>                  
                    <div class="card-image">
                      <strat_grid_amchart :chart_data="item.data" :ben_name="item.ben_name"></strat_grid_amchart>
                    </div>
                    <div class="details">
                      <div class="details_block" style="font-size: 1.2em; font-weight: 550; color: rgb(237, 65, 65); padding-top:5px">
                        <div style="display:flex; padding-top:10px">{{ item.stPrice }}元/月</div>
                      </div>
                      <div style="flex: 20px"></div>
                      <div class="details_block">
                        <div class="details_block_top">资金上限</div>
                        <div class="details_block_bottom">{{ item.fundingCap }}万</div>
                      </div>
                      <div style="flex: 1px"></div>
                      <div class="details_block">
                        <div class="details_block_top">实盘天数</div>
                        <div class="details_block_bottom">{{ item.realTradingDays }}天</div>
                      </div>
                      <div style="flex: 1px"></div>
                      <div class="details_block">
                        <div class="details_block_top">实盘收益</div>
                        <div class="details_block_bottom" style="padding-top: 3.5px">{{ item.realTradingReturns }}%</div>
                      </div>
                    </div>
                  </div>
                </button>
              </router-link>
            </el-card>
          </el-col>
        </div>
      </el-row>
      <el-pagination
        style="justify-content: center; padding:30px"
        background
        @current-change="handleCurrentChange"
        :current-page.sync="parseInt(boardInfo.pageNum)"
        :page-size=9
        layout="prev, pager, next"
        :page-count="parseInt(boardInfo.pages)">
      </el-pagination>
    </div>
  </template>
  
  <script>
  import { reactive, onMounted } from 'vue'
  import { useRouter} from "vue-router"
  
  import strat_grid_amchart from '@/components/strat_board_amcharts/strat_grid_amchart.vue'
  import API from "@/api/axiosInstance"
  
  export default {
      name: 'StrategiesBoardView',
      components: {
        strat_grid_amchart
      },
      setup() {
        const router = useRouter();
        // set up the variables for storing data from server
        let data = reactive([]);            // variable to store all data from server
        let boardInfo = reactive([]);       // general info for board, like pages etc.
        let strategiesList = reactive([]);  // strategies' info for demonstration
        var currentPage = "1";
        
        //从sessionStorage得到当前要显示的页数
        const getPage = () => {
          let sessionPage = sessionStorage.getItem('strategyListPage');
            if (sessionPage != null) {
              currentPage = sessionPage
            } else {
              currentPage = "1"
            }
        }
        getPage();
  
        function getData(pageNum){
          let moment = require('moment');
          // get data from server
          API({
              url:'/ios.ashx?typedata=strategiesreview&querytype=2&page='+ pageNum +'&pagesize=9&benchcode=sh000300&date=2022-01-01&interval=1',
              method:'get'
          }).then((res)=>{
            // mapping the server data
            data.data = res.data.list策略;
            // TODO: extracting board info?
            boardInfo.pageNum = res.data.pageNum;
            boardInfo.pages = res.data.pages;
  
            // clear the strategy list
            strategiesList.splice(0, strategiesList.length);
            data.data.forEach(function(item) {
              // set up a variable for storing all info for a strategy
              let strategy = {
                name: "",
                author: "",
                ben_name:"",
                realTradingDays: "",
                realTradingReturns: "",
                stPrice: "",
                fundingCap: "",
                data: [{
                  date: "",
                  value: "",
                  bench_value: ""
                }]
              };
  
              // mapping description of the strategy
              strategy.name = item.策略名称;
              strategy.ben_name = item.基准名称;
              strategy.author = item.策略作者;
              strategy.realTradingDays = item.实盘天数;
              strategy.realTradingReturns = item.策略累计收益率.toFixed(2);
              strategy.stPrice = item.策略定价;
              strategy.fundingCap = item.资金上限;
  
              // adjusting data for echart 
              // turning list of objects into three corresponding arrays
              strategy.data.length = 0;
              item.data.forEach(function(strat) {
                strategy.data.push({
                  date:moment(strat.utc).format('YYYY/MM/DD'),//strat.utc,
                  value: Number(strat.vpct),   
                  bench_value: Number(strat.b_vpct),
                })
              })
              
              // adding the strategy back to the list
              strategiesList.push(strategy);
            })
          });
        }
  
        // 根据页码刷新列表
        function handleCurrentChange(val) {
          getData(val);
          sessionStorage.setItem('strategyListPage', val);
        }
  
        onMounted(() => {
          if (router.currentRoute.value.path == "/home") {
            // 不清除
          } else {
            sessionStorage.removeItem('strategyListPage')
          }
          getData(currentPage);
        });
  
        return { boardInfo, strategiesList, currentPage, handleCurrentChange };
      }
  }
  </script>
  
  <style lang="scss" scoped>
  .el-card {
    width: 375px; 
    height: 350px; 
    margin-bottom: 30px; 
    display: flex; 
    justify-content: center; 
    align-content: center; 
    border-radius: 8px;
  }
  
  .strategy_card {
    width: 375px;
    height: 350px;
    border: 0px;
    background-color: transparent;
  }
  
  .card {
    width: 375px;
    height: 350px;
    background-color: white;
    padding: 1em;
    border-radius: 8px;
  }
  
  .card-image {
    background-color: whitesmoke;
    width: 100%;
    height: 70%;
    border-radius: 6px 6px 6px 6px;
    display: flex;
    justify-content: center;
  }
  
  .card-image:hover {
    transform: scale(0.98);
  }
  
  .heading {
    height: 50px;
    line-height: 50px;
    display: flex;
  }
  
  .heading:hover {
    cursor: pointer;
  }
  
  .title {
    font-size: 18px;
    font-weight: 550;
    color: rgb(63, 121, 230);
    padding-left: 15px;
    display: flex;
    text-align: center;
  }
  
  .author {
    color: rgb(88, 88, 88);
    font-weight: 520;
    font-size: 14px;
    padding-right: 20px;
    display: flex;
    text-align: center;
  }
  
  .author:hover {
    cursor: pointer;
  }
  
  .details {
    height: 100px;
    padding: 0px 20px 0;  
    display: flex;
  }
  
  .details_block {
    color: rgb(88, 88, 88);
    font-size: 1em;
    display: block;
  }
  
  .details_block_top {
    display:flex; 
    justify-content: right; 
    padding-top: 10px;
    padding-bottom: 1px;
  }
  
  .details_block_bottom {
    display:flex; 
    justify-content: right; 
    padding-top: 1px;
  }
  </style>   
  
  <style>
  .el-pagination.is-background .el-pager li{
    background-color: white;
  }
  </style>